import { sortDestinationIdFormat } from "@redotech/redo-ids-cockroach";
import * as z from "zod";

export const deleteSortDestination = {
  name: "deleteSortDestination" as const,
  input: z.object({ id: sortDestinationIdFormat.schema }),
  output: z.null(),
};
